// components/ContactForm.jsx
import React, { useState } from "react";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const [sendMethod, setSendMethod] = useState("email");

  const services = [
    "Web Development",
    "Mobile App Development",
    "Graphics Design",
    "Photography",
    "Digital Marketing",
    "Print on Demand",
    "Other",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (sendMethod === "email") {
      sendViaEmail();
    } else {
      sendViaWhatsApp();
    }
  };

  const sendViaEmail = () => {
    const subject = `New Contact Form Submission - ${formData.service}`;
    const body = `
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Service: ${formData.service}

Message:
${formData.message}

---
This message was sent from your website contact form.
    `.trim();

    const mailtoLink = `mailto:ceo@teckpik.com?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const sendViaWhatsApp = () => {
    const message = `
*NEW CONTACT FORM SUBMISSION*

*Name:* ${formData.name}
*Email:* ${formData.email}
*Phone:* ${formData.phone}
*Service Interested In:* ${formData.service}

*Message:*
${formData.message}

---
This message was sent from your website contact form.
    `.trim();

    const whatsappLink = `https://wa.me/923170725045?text=${encodeURIComponent(
      message,
    )}`;
    window.open(whatsappLink, "_blank");
  };

  const isFormValid =
    formData.name &&
    formData.email &&
    formData.phone &&
    formData.service &&
    formData.message;

  return (
    <div className="contact-form-container">
      <h2 className="form-title fw-bold">Send Us a Message</h2>
      <p className="form-subtitle">
        Fill out the form below and we'll get back to you as soon as possible
      </p>

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Full Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter your full name"
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter your email address"
                required
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="phone" className="form-label">
                Phone Number *
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter your phone number"
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="service" className="form-label">
                Service Interested In *
              </label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleInputChange}
                className="form-input"
                required
              >
                <option value="">Select a service</option>
                {services.map((service, index) => (
                  <option key={index} value={service}>
                    {service}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="message" className="form-label">
            Message *
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            className="form-textarea"
            placeholder="Tell us about your project requirements..."
            rows="6"
            required
          ></textarea>
        </div>

        {/* Send Method Selection */}
        <div className="send-method-section">
          <h4 className="method-title">
            How would you like to send your message?
          </h4>
          <div className="method-options">
            <label className="method-option">
              <input
                type="radio"
                name="sendMethod"
                value="email"
                checked={sendMethod === "email"}
                onChange={(e) => setSendMethod(e.target.value)}
                className="method-radio"
              />
              <span className="method-label">
                <span className="method-icon">📧</span>
                Send via Email
              </span>
            </label>
            <label className="method-option">
              <input
                type="radio"
                name="sendMethod"
                value="whatsapp"
                checked={sendMethod === "whatsapp"}
                onChange={(e) => setSendMethod(e.target.value)}
                className="method-radio"
              />
              <span className="method-label">
                <span className="method-icon">💬</span>
                Send via WhatsApp
              </span>
            </label>
          </div>
        </div>

        <button
          type="submit"
          className={`submit-btn ${!isFormValid ? "disabled" : ""}`}
          disabled={!isFormValid}
        >
          {sendMethod === "email" ? "Send Email" : "Open WhatsApp"}
        </button>

        {!isFormValid && (
          <p className="form-note text-muted small mt-2">
            * Please fill all required fields to enable submission
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
